import classnames from "classnames";
import SVG from "react-inlinesvg";

import GuarantorIcon from "@krea/common/images/svg/guarantor.svg";
import { IGuarantor } from "@krea/common/types/fieldRequests/guarantor";

interface IGuarantorItemProps {
  guarantor: IGuarantor;
}

export const GuarantorPreviewItem = ({ guarantor }: IGuarantorItemProps) => {
  const showName = !!(guarantor.firstName || guarantor.lastName);

  return (
    <div className="tw-flex tw-align-start tw-mt-2">
      <div
        className={classnames(
          "tw-relative tw-mt-[2px] tw-w-[18px] tw-h-[18px] tw-shrink-0",
        )}
      >
        <SVG
          className="tw-absolute tw-w-full tw-h-auto tw-top-0 tw-left-0"
          src={GuarantorIcon}
        />
      </div>
      <div className="tw-pl-2 tw-w-full">
        {showName && (
          <div className="tw-inline-block tw-mr-2">
            {guarantor.firstName} {guarantor.lastName}
          </div>
        )}

        <div className="tw-inline-block tw-mr-2">{guarantor.ssn}</div>
        <div className="tw-inline-block">{`(${guarantor.email})`}</div>
      </div>
    </div>
  );
};
